import { resolveButtonClassName, overrideButtonStyle } from "./resolveButtonStyle"

type Props = {
  href?: string
  children?: React.ReactNode
  overrideStyle?: Parameters<typeof overrideButtonStyle>[0]
  cancelNavigation?: () => boolean
} & Parameters<typeof resolveButtonClassName>[0]

const LinkLikeButton = ({ href, children, overrideStyle, cancelNavigation = () => false, ...props }: Props) => {
  const { disabled = false } = props
  return (
    <a
      href={disabled ? undefined : href}
      css={resolveButtonClassName(props)}
      style={overrideButtonStyle(overrideStyle)}
      onClick={(event) => {
        if (cancelNavigation()) {
          event.preventDefault()
        }
      }}
    >
      {children}
    </a>
  )
}

export default LinkLikeButton
